import type {BioIconProps} from './common-types'

export function IconFacebook({...attributes}: BioIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none" {...attributes}>
      <path
        d="M32 16.25C32 7.4135 24.8365 0.25 16 0.25C7.1635 0.25 0 7.41337 0 16.25C0 24.236 5.851 30.8554 13.5 32.0556V20.875H9.4375V16.25H13.5V12.725C13.5 8.715 15.8888 6.5 19.5434 6.5C21.294 6.5 23.125 6.8125 23.125 6.8125V10.75H21.1075C19.1198 10.75 18.5 11.9834 18.5 13.2487V16.25H22.9375L22.2281 20.875H18.5V32.0556C26.149 30.8554 32 24.2361 32 16.25Z"
        fill="#1877F2"
      />
      <path
        d="M22.2281 20.875L22.9375 16.25H18.5V13.2487C18.5 11.9832 19.1199 10.75 21.1075 10.75H23.125V6.8125C23.125 6.8125 21.294 6.5 19.5434 6.5C15.8888 6.5 13.5 8.715 13.5 12.725V16.25H9.4375V20.875H13.5V32.0556C14.327 32.1852 15.1629 32.2502 16 32.25C16.8371 32.2502 17.673 32.1853 18.5 32.0556V20.875H22.2281Z"
        fill="white"
      />
    </svg>
  )
}
